import React, { useCallback, useEffect, useMemo } from "react";

import _ from "lodash";
import { Div } from "nexcomponent-ui";
import { useSelector } from "react-redux";

import { productBreadCrumb } from "../../../../Enum/Breadcrumb/ProductBreadcrumb";
import { MAPPING_CODE } from "../../../../Enum/MappingCode/MappingCode";
import { ROUTER_CONSTANT } from "../../../../Enum/RouterConstant/RouterConstant";
import {
  fetchDataApprovalProduct,
  fetchProductMappingForm,
} from "../../../../Fetch/FetchData/ProductData";
import { mappingFormPageStateGroup } from "../../../../Store/StateGroup";
import CancelOverwrite from "../../../Organisms/Button/CancelOverwrite/CancelOverwrite";
import MappingForm from "../../../Organisms/Form/MappingForm/MappingForm/MappingForm";
import HeaderPageMapping from "../../../Organisms/Header/HeaderPageMapping/HeaderPageMapping";
import ModalMapping from "../../../Organisms/Modal/ModalMapping/ModalMapping";
import useQueryRoute from "../../../../Hooks/useQueryRoute";
import {
  fetchDataApprovalProductPrincipal,
  fetchProductPrincipalMappingForm,
} from "../../../../Fetch/FetchData/ProductPrincipalData";

const ProductMappingPage = (props) => {
  const { principal } = useQueryRoute();

  const [, list, , mappingForm] = useSelector(mappingFormPageStateGroup);

  const key = useMemo(() => (principal ? "principal_product_id" : "product_id"), [principal]);

  const approveFuc = useCallback(
    (data, mappingList, mappingCount) => {
      if (principal) {
        return fetchDataApprovalProductPrincipal(
          props.validToken(),
          data,
          mappingList,
          mappingCount,
          props.notify,
          props.dispatch
        );
      } else {
        return fetchDataApprovalProduct(
          props.validToken(),
          data,
          mappingList,
          mappingCount,
          props.notify,
          props.dispatch
        );
      }
    },
    [principal, props]
  );

  const nextMapping = useCallback(
    (uniqueKey, newId, existId, mappingList) => {
      if (principal) {
        return fetchProductPrincipalMappingForm(
          props.validToken(),
          props.dispatch,
          uniqueKey,
          newId,
          existId,
          mappingList,
          props.notify,
          () => props.navigate(`${ROUTER_CONSTANT.PRODUCT.PRINCIPAL.MAPPING}`)
        );
      } else {
        return fetchProductMappingForm(
          props.validToken(),
          props.dispatch,
          uniqueKey,
          newId,
          existId,
          mappingList,
          props.notify,
          () => props.navigate(ROUTER_CONSTANT.PRODUCT.MAPPING)
        );
      }
    },
    [principal, props]
  );

  useEffect(() => {
    if (_.has(props.location.state, "data")) {
      const first = _.first(list);
      if (principal) {
        fetchProductPrincipalMappingForm(
          props.validToken(),
          props.dispatch,
          "principal_product_id",
          first.id,
          props.location.state.data.principal_product_id,
          list,
          props.notify,
          () => props.navigate(`${ROUTER_CONSTANT.PRODUCT.PRINCIPAL.MAPPING}`)
        );
      } else {
        fetchProductMappingForm(
          props.validToken(),
          props.dispatch,
          "product_id",
          first.id,
          props.location.state.data.product_id,
          list,
          props.notify,
          () => props.navigate(ROUTER_CONSTANT.PRODUCT.MAPPING)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, principal, props.location.state, props.dispatch, props.validToken]);

  return (
    <Div>
      <ModalMapping
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        listNavigate={ROUTER_CONSTANT.PRODUCT.LIST}
        approveFuc={approveFuc}
        uniqueKey={key}
        nextMapping={nextMapping}
      />

      <HeaderPageMapping
        title={props.t("PRODUCT:TITLE")}
        listBreadcrumb={productBreadCrumb(props.t)}
        defaultBreadcrumb={props.t("PRODUCT:MAPPING.TITLE")}
        to={ROUTER_CONSTANT.PRODUCT.LIST}
      />
      <MappingForm
        t={props.t}
        validToken={props.validToken}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey={key}
        mappingCode={MAPPING_CODE.PRODUCT}
        mappingForm={mappingForm}
      />
      <CancelOverwrite
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey={key}
        mappingForm={mappingForm}
        mappingCode={MAPPING_CODE.PRODUCT}
      />
    </Div>
  );
};

export default ProductMappingPage;
